import { Button, Dropdown, Menu } from "semantic-ui-react";

import AccountMenu from "./AccountMenu";
import AppBar from "material-ui/AppBar";
import { LIST_PATH } from "constants";
import { Link } from "react-router";
import LoginMenu from "./LoginMenu";
import PropTypes from "prop-types";
import React from "react";
import classes from "./Navbar.scss";

export const Navbar = ({
  avatarUrl,
  displayName,
  authExists,
  goToAccount,
  handleLogout
}) => (
  <div>
    <Menu size="mini">
      <Menu.Item
        name="home"
        active={activeItem === "home"}
        onClick={this.handleItemClick}
      />
      <Menu.Item
        name="messages"
        active={activeItem === "messages"}
        onClick={this.handleItemClick}
      />

      <Menu.Menu position="right">
        <Dropdown item text="Language">
          <Dropdown.Menu>
            <Dropdown.Item>English</Dropdown.Item>
            <Dropdown.Item>Russian</Dropdown.Item>
            <Dropdown.Item>Spanish</Dropdown.Item>
          </Dropdown.Menu>
        </Dropdown>

        <Menu.Item>
          <Button primary>Sign Up</Button>
        </Menu.Item>
      </Menu.Menu>
    </Menu>

    <AppBar
      title={
        <Link to={authExists ? LIST_PATH : "/"} className={classes.brand}>
          GluteMarket
        </Link>
      }
      showMenuIconButton={false}
      iconElementRight={
        authExists ? (
          <AccountMenu
            avatarUrl={avatarUrl}
            displayName={displayName}
            onLogoutClick={handleLogout}
            goToAccount={goToAccount}
          />
        ) : (
          <LoginMenu />
        )
      }
      iconStyleRight={authExists ? { marginTop: 0 } : {}}
      className={classes.appBar}
    />
  </div>
);

Navbar.propTypes = {
  displayName: PropTypes.string, // from enhancer (flattenProps - profile)
  avatarUrl: PropTypes.string, // from enhancer (flattenProps - profile)
  authExists: PropTypes.bool, // from enhancer (withProps - auth)
  goToAccount: PropTypes.func.isRequired, // from enhancer (withHandlers - router)
  handleLogout: PropTypes.func.isRequired // from enhancer (withHandlers - firebase)
};

export default Navbar;



// WEBPACK FOOTER //
// ./src/containers/Navbar/Navbar.js